import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil, Subject } from 'rxjs';
import { InteractionStatus, AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AuthorizedUserService } from 'src/app/services/authorized-user.service';
import { FiberService } from 'src/app/services/fiber.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { PageService } from 'src/app/services/page.service';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

interface PageList {
  id: number
  pageName: string
  pageCaption: string
  pageURL: string
  parentPageId?: number
  orderNo: number
  iconClass: string
  containerWidth: number
  pageNavigationState?: string
  pageType: number
  roleControlMapping: RoleControlMapping[]
}
interface RoleControlMapping {
  roleId: number
  pageId: number
  layoutControlId: number
  layoutControl: LayoutControl
  isEnabled: boolean
  id: number
  creationTs: string
  creationUserId: string
  isNewRecord: boolean
  errorList: any[]
  isValid: boolean
}

interface LayoutControl {
  controlName: string
  controlType: string
  labelName: string
  toolTip: string
  isDefault: boolean
  isVisible: boolean
  event: string
  sequenceNumber: number
  id: number
  creationTs: string
  creationUserId: string
  isNewRecord: boolean
  errorList: any[]
  isValid: boolean
}

@Component({
  selector: 'app-microsoft-login-redirection',
  templateUrl: './microsoft-login-redirection.component.html',
  styleUrls: ['./microsoft-login-redirection.component.scss'],
})


export class MicrosoftLoginRedirectionComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  LoginDetials: any;
  private isProcessing = false;

  constructor(
    private authservice: AuthenticationService,
    private userSessionService: UserSessionService,
    private _fiberService: FiberService,
    private navigate: NavigationService,
    private msal: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private sharedDataService: SharedDataService,
    private authorizedUserSessionService: AuthorizedUserService,
    private pageService: PageService,

  ) {
    const preloader = document.querySelector('.loader-bg1');

    if (preloader === null) {
      return;
    }

    preloader.addEventListener('transitionend', (event: Event) => {
      if (event instanceof TransitionEvent && event.propertyName === 'opacity') {
        preloader.remove();
      }
    });
    preloader.classList.add('site-preloader__fade');

    // Sometimes, due to unexpected behavior, the browser (in particular Safari) may not play the transition, which leads
    // to blocking interaction with page elements due to the fact that the preloader is not deleted.
    // The following block covers this case.
    if (getComputedStyle(preloader).opacity === '0' && preloader.parentNode) {
      preloader.parentNode.removeChild(preloader);
    }
  }

  ngOnInit(): void {
    console.log('MicrosoftLoginRedirectionComponent initialized');

    // Try processing immediately
    this.processRedirect();

    // Also listen for status changes in case it was in progress
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe((status) => {
        console.log('InteractionStatus.None detected, processing redirect...');
        this.processRedirect();
      });
  }

  processRedirect(): void {
    if (this.isProcessing) {
      console.log('Redirect already being processed, skipping...');
      return;
    }

    console.log('Starting processRedirect. Location hash:', window.location.hash);
    console.log('Account info:', this.msal.instance.getAllAccounts());
    this.isProcessing = true;
    this.msal.handleRedirectObservable()
      .pipe(takeUntil(this._destroying$))
      .subscribe({
        next: (result: AuthenticationResult | null) => {
          if (result) {
            console.log('Redirect result found in component:', result);
            this.msal.instance.setActiveAccount(result.account);
            this.LoginDetials = result;
            this.sharedDataService.setValue('MicroSoftLogin', this.LoginDetials)
            this.handleMicrosoftLoginRedirection(result);
          } else {
            console.log('No redirect result in component, checking existing accounts...');
            const account = this.msal.instance.getActiveAccount()
              ?? this.msal.instance.getAllAccounts()?.[0];

            if (account) {
              this.msal.instance.setActiveAccount(account);
              // Acquire token silently to get the latest access token
              this.msal.instance.acquireTokenSilent({
                scopes: ['openid', 'profile', 'email'],
                account: account
              }).then((silentResult) => {
                this.LoginDetials = silentResult;
                this.sharedDataService.setValue('MicroSoftLogin', this.LoginDetials)

                this.handleMicrosoftLoginRedirection(silentResult);
              }).catch((err) => {
                console.error('Silent token acquisition failed:', err);
                this.clearMsalAndAppStorage();
              });
            } else {
              console.warn('No active account found after redirect.');
              this.clearMsalAndAppStorage();
            }
          }
        },
        error: (error) => {
          console.error('Error in handleRedirectObservable:', error);
          this.clearMsalAndAppStorage();
        }
      });
  }


  handleMicrosoftLoginRedirection(result: AuthenticationResult) {
    const claims: any = result.idTokenClaims;
    const email = claims.preferred_username || claims.email || claims.upn;

    const payload = {
      useremail: email,
      microsoftToken: result.accessToken,
      isUssd: false
    };
    this.authservice.login(payload).subscribe((res) => {
      if (res) {
        debugger
        const sessionDataString = localStorage.getItem(
          this.userSessionService.localStorageSessionKey
        );
        if (sessionDataString) {
          const localStorageData = JSON.parse(sessionDataString);
          console.log(localStorageData);

        }
        var tokenStr = new String(res.access_token)
        console.log('tokenStr : ', tokenStr);
        debugger
        if (tokenStr.length > environment.TokenLength) {
          localStorage.setItem('isLoggedin', 'true');
          localStorage.setItem('token', res.access_token);

          const roleId = this.userSessionService.getValue('roleId');

          this._fiberService.getMenuByRoleIdObs(roleId).subscribe((menu) => {
            var menuItems = menu?.sort((a, b) => a.orderNo - b.orderNo);
            menuItems = menuItems?.map((menu) => {
              return {
                ...menu,
                iconName: `${menu.pageCaption?.replace(/ /g, '_')}.svg`,
              };
            });

            const idToMenuMap = menuItems?.reduce((map, menuItem) => {
              map[menuItem.id] = menuItem;
              return map;
            },
              {}
            );
            menuItems = menuItems?.filter((menuItem) => {
              const parentId = menuItem.parentPageId;
              if (parentId !== null) {
                const parentMenu =
                  idToMenuMap[parentId];
                if (parentMenu) {
                  if (!parentMenu.subMenu) {
                    parentMenu.subMenu = [];
                  }
                  parentMenu.subMenu.push(
                    menuItem
                  );
                  return false;
                }
              }
              return true;
            }
            );
            this.userSessionService.setLocalStorageWithKey(
              'menu',
              menuItems
            );
            this.sharedDataService.setValue('isFirsttime', true);
            this.sharedDataService.setValue('logedin', true);
            this.authorizedUserSessionService.setValue('isAuthorizedUser', false);
            this.pageService.getPagesByRoleId().subscribe((res: PageList[]) => {
              if (res) {
                this.navigationPage(res, roleId);
              }
            });
          });
        }
      }
      else {
       this.clearMsalAndAppStorage();

      }
    }, (error) => {
      this.clearMsalAndAppStorage();
    });
  }

  navigationPage(pagelist: PageList[], roleId?: number) {
    this.authorizedUserSessionService.setValue('MicrosoftLogin', true);
    if (roleId == 7) {
      this.navigate.resellerapplication();
      return;
    }
    pagelist.sort((a: PageList, b: PageList) => a.orderNo - b.orderNo);

    const currentFirstPage: PageList = pagelist[0];

    if (currentFirstPage) {
      this.navigate.gotolandingpage();
    }

  }

  encryptPayload(payload) {
    debugger
    if (payload.Password) {
      const payloadString = JSON.stringify(payload);
      const password = "afrihosthc";
      const key = CryptoJS.SHA256(password);
      const iv = CryptoJS.lib.WordArray.random(128 / 8);
      const encrypted = CryptoJS.AES.encrypt(payloadString, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7
      }).toString();
      const base64Iv = CryptoJS.enc.Base64.stringify(iv);
      var combinedData = encrypted + ':' + base64Iv + ':HCAL';
      return payload.Password
    }
    else
      return null

  }


  clearMsalAndAppStorage(): void {
    this.msal.instance.setActiveAccount(null);

    Object.keys(localStorage)
      .filter(key =>
        key.startsWith('msal.') ||
        key.includes('login.windows.net') ||
        key.includes('login.microsoftonline')
      )
      .forEach(key => localStorage.removeItem(key));

    Object.keys(sessionStorage)
      .filter(key =>
        key.startsWith('msal.') ||
        key.includes('login.windows.net') ||
        key.includes('login.microsoftonline')
      )
      .forEach(key => sessionStorage.removeItem(key));

    localStorage.removeItem('isLoggedin');
    localStorage.removeItem('token');

    this.navigate.login();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
